export const lang = {
  //common
  cancel: 'Cancel',
  confirm: 'Confirm',

  // files
  deletemessage: 'Record deleted successfully',
  TVURecordingService: 'Recording Service',
  language: 'Language',
  theme: 'Theme',
  light:  'Light',
  dark:   'Dark',
  logout: 'Logout',
  name: 'Name',
  owner: 'Owner',
  updateTime: 'Update time',
  startTime: 'Start time',
  endTime: 'End time',
  fileSize: 'Approx Size',
  markerFileSize: 'File Size',

  empty: 'Empty',
  recordedFile: 'Recorded files',
  remoteRecordedFile: 'Remote Recorded files',

  markerFile: 'Marker files',
  remoteRecordFile: 'Remote Record Files',

  download: 'Download',
  searchSession: 'Name',
  downloadTipTitle: 'Auto-download after finishing transcode',
  downloadTipContent:
    'The system is preparing to get the files ready to succesfully download. Please do not close the page at this stage.',
  dontShow: 'Do not show this again.',
  gotIt: 'Got it, Preparing to download.',
  Transcoding: 'Downloading...',
  selectTimeRange: 'Please select the time range',
  selectTimeRangeError1: 'Please select download clip from ',
  selectTimeRangeError2: ' to ',
  selectTimeRangeError3: 'Please select download clip time ',
  startDownload: 'Start Download',
  downloadTips:
    'Please wait a few mintues for transcoding the files, system will download files automatically when transcode finished.',
  deleteFile: 'Delete the folder?',
  deleteMarkerFile: 'Delete the file?',

  deleteFileConfirm: 'Are you sure to delete this folder? All content can not be recovered.',
  deleteMarkerFileConfirm: 'Are you sure to delete this file?',

  delete: 'Delete',
  downloadFail: 'Download failed, please refresh and try again.',
  multiDeleteHeading: 'Delete the item',
  multiDeleteContent: 'Are you sure to delete all items? Content can not be recovered',
  //server
  serverFailed: 'Request failed. Please try again',
  timeOut: 'Request timed out. Please try again.',
  action: 'Action',
  clippping: 'Clipping',
  tvuSearch: 'Tvu Search',
  error: 'Something went wrong. Please refresh the page and try again',
  //公共提示代码
  810000014: 'Something went wrong. Please refresh the page and try again',
  81000006: 'Something went wrong. Please refresh the page and try again',
  81000017: 'Sorry, recording files are not allowed to be deleted',
  // 81000017: 'Sorry, the recording failed to delete.',
  81000001: 'Please log in first',
  81000002: 'Something went wrong. Please refresh the page and try again',
  81000003: 'Something went wrong. Please refresh the page and try again',
  810000015: 'Sorry, the file being recorded cannot be deleted',
};
